/**
 * Find closest scrollable parent
 * This is handy for triggering scroll events without having to manually define
 * the scrollable parent.
 *
 * @param {HTMLElement} [node]
 */
export const getClosestScrollableParent = (node: HTMLElement | null): HTMLElement | null => {
  if (node === null) {
    return null;
  }

  const styles = getComputedStyle(node);

  if (node.scrollHeight > node.clientHeight && ['scroll', 'auto'].includes(styles.overflow)) {
    return node;
  }

  return getClosestScrollableParent(node.parentElement);
};

/**
 * Returns true if the element can be scrolled vertically. This does not take
 * CSS like `overflow: hidden` into consideration.
 */
export const isElementScrollable = (element: HTMLElement) =>
  element.offsetHeight < element.scrollHeight;
